"use client";
export { default } from "@/components/RouteErrorBoundary";
